import { SR_API_ACTION_GET_LISTINGS_ELIGIBLE_FOR_DISCOUNTS } from 'api/actionTypes';

export default async function getListingsEligibleForDiscounts(
  { state, apiClient },
  { partnerSlug, forceRefresh },
) {
  const statePath = ['listingsEligibleForDiscounts', 'byPartnerSlug', partnerSlug];
  if (state.exists(statePath) && !forceRefresh) {
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTINGS_ELIGIBLE_FOR_DISCOUNTS,
    state: state,
    payload: {
      partnerSlug,
    },
    onSuccess(listingsEligibleForDiscounts) {
      state.set(statePath, listingsEligibleForDiscounts);
    },
  });
}
